import axios from "axios";
import { OfflineQueue } from "./offlineQueue";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
  withCredentials: true,
});

// --- Offline queue interceptor ---
// When a POST/PUT to a Quick-Log endpoint fails because the device has no
// signal, stash the request in IndexedDB and return a synthetic 202 response
// so the UI keeps moving. The queue flushes automatically when the browser
// reports back online.
api.interceptors.response.use(undefined, async (error) => {
  const cfg = error?.config || {};
  const method = cfg.method?.toUpperCase() || "GET";
  const isNetworkError =
    !error.response || error.code === "ERR_NETWORK" || error.message === "Network Error";
  if (!isNetworkError) throw error;
  const raw = cfg.url || "";
  const normalizedUrl = raw.startsWith("http")
    ? raw
    : `/api${raw.startsWith("/") ? "" : "/"}${raw}`;
  if (!OfflineQueue.isQueueable(method, normalizedUrl)) throw error;
  let parsedBody = cfg.data;
  if (typeof parsedBody === "string") {
    try { parsedBody = JSON.parse(parsedBody); } catch { /* ignore */ }
  }
  await OfflineQueue.enqueue({
    method,
    url: normalizedUrl,
    body: parsedBody,
    headers: {},
  });
  return {
    status: 202,
    statusText: "Queued offline",
    data: { ...(parsedBody || {}), _offline_draft: true, _queued_at: new Date().toISOString() },
    headers: {},
    config: cfg,
    request: null,
  };
});

export const EXPENSE_CATEGORIES = [
  { value: "seed", label: "Seed" },
  { value: "fertilizer", label: "Fertilizer" },
  { value: "chemicals", label: "Chemicals" },
  { value: "fuel", label: "Fuel" },
  { value: "labor", label: "Labor / Hired Help" },
  { value: "equipment", label: "Equipment & Repair" },
  { value: "vet", label: "Vet & Medicine" },
  { value: "feed", label: "Feed (Livestock)" },
  { value: "livestock_purchase", label: "Livestock Purchase" },
  { value: "breeding", label: "Breeding Fees" },
  { value: "insurance", label: "Insurance" },
  { value: "lease", label: "Land Lease / Rent" },
  { value: "utilities", label: "Utilities" },
  { value: "other", label: "Other" },
];

export const CROP_TYPES = [
  "Corn", "Soybeans", "Wheat", "Hay", "Oats", "Barley",
  "Cotton", "Sorghum", "Rice", "Canola", "Sunflower", "Other",
];

export const fmtUSD = (n) =>
  new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(n || 0);

export const fmtNum = (n, digits = 2) =>
  new Intl.NumberFormat("en-US", { maximumFractionDigits: digits }).format(n || 0);

export const todayISO = () => new Date().toISOString().slice(0, 10);
